import React from "react";
import {toCSS} from "../Tools/toCSS";
import styled from "styled-components";

export interface IGridProps {
    columns: number;
    rows: number;
    children?: JSX.Element | JSX.Element[] | React.ReactNode;
    fullHeight?: boolean;
    fullWidth?: boolean;
    gridStyles?: Partial<CSSStyleDeclaration>;
}

export const Grid = styled.div<IGridProps>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  grid-template-rows: repeat(${(props) => props.rows}, 1fr);
  height: ${(props) => (props.fullHeight ? "100%" : "initial")};
  width: ${(props) => (props.fullWidth ? "100%" : "initial")};
  ${(props) => props.gridStyles && toCSS(props.gridStyles)}
`;
